import { global_video_full_bleed_hero } from '../../../utils/requests/contentstack/contentStackZodSchema';
import type { VideoFullBleedHeroProps } from './VideoFullBleedHero';
import { getCloudinaryAspectRatio, getCloudinarySourceUrl, isCloudinary } from '../../../utils/getCloudinaryItem/getCloudinaryItem';
import { formatAspectRatio } from '../../CloudinaryImageWrapper/CloudinaryImageWrapper';
const getVideoProps = (src: unknown) => {
  if (!isCloudinary(src)) {
    return undefined;
  }
  const isVideo = src[0].resource_type === 'video';
  if (isVideo) {
    const videoUrl = getCloudinarySourceUrl(src);
    const aspectRatio = formatAspectRatio(getCloudinaryAspectRatio(src));
    const duration = src[0].duration ?? 0;
    return {
      videoUrl,
      aspectRatio,
      duration
    };
  }
  return undefined;
};
export const videoFullBleedHeroSchema = global_video_full_bleed_hero.transform<VideoFullBleedHeroProps>(data => ({
  desktopVideo: getCloudinarySourceUrl(data.desktop_video),
  tabletVideo: getCloudinarySourceUrl(data.tablet_video),
  mobileVideo: getCloudinarySourceUrl(data.mobile_video),
  mobileVideoAspectRatio: getVideoProps(data.mobile_video)?.aspectRatio,
  tabletVideoAspectRatio: getVideoProps(data.tablet_video)?.aspectRatio,
  desktopVideoAspectRatio: getVideoProps(data.desktop_video)?.aspectRatio,
  titleText: data.title.title_text,
  titleShadow: data.title.title_shadow,
  titleHiddenFromView: data.title.hide_title_from_view,
  ctaText: data.cta_text,
  ctaHref: data.cta_href,
  ctaHiddenFromView: data.cta_hidden_from_view,
  ctaColor: data.cta_color,
  videoDescription: data.video_description,
  soundControls: data.sound_controls,
  captions: {
    url: getCloudinarySourceUrl(data.captions.file),
    default: data.captions.default,
    label: data.captions.label
  },
  contentOrder: data.content_order,
  playPauseButtonSize: data.play_pause_button_size ?? 'large'
}));